/**
 * Vue Store related to tracking editor state.
 *
 * @author Documill 2025
 */

export default {

  state: {
    openEditors: [],
  },

  getters: {
    hasOpenEditors: (state) => () => {
      return state.openEditors.length > 0;
    }
  },

  mutations: {
    recordEditorOpen(state, editorId) {
      // TODO: Consider avoiding duplicates.
      state.openEditors.push(editorId);
    },

    recordEditorClosed(state, editorId) {
      for(let i = 0; i < state.openEditors.length; ++i) {
        if(state.openEditors[i] == editorId) {
          state.openEditors.splice(i,1);
          --i; // Adjust counter before ++i as we removed an element
        }
      }
    },
  },

  actions: {
    async recordEditorOpen(context, editorId) {
      // See DocumentEditor.vue editorId for possible values.
      // As of writing this, they are based on either task or document ids.
      context.commit("recordEditorOpen",editorId);
    },

    async recordEditorClosed(context, editorId) {
      context.commit("recordEditorClosed",editorId);
    },
  },

}
